import { ChartDatum, DataWithArrays } from "./types";

export function makeTicksFromData(
    data: ChartDatum<DataWithArrays>[],
    key: string,
    step = 250
): number[] {
    if (!data?.length) return [];
    // index の min/max を取得
    let min = Infinity, max = -Infinity;
    for (const d of data) {
        const v = Number(d[key]);
        if (Number.isFinite(v)) {
            if (v < min) min = v;
            if (v > max) max = v;
        }
    }
    if (!Number.isFinite(min) || !Number.isFinite(max)) return [];

    // 250 刻みで開始・終了を丸める
    const start = Math.ceil(min / step) * step;      // 例: min=0 → 0, min=3 → 250
    const end = Math.floor(max / step) * step;     // 例: max=1999 → 1750
    const ticks: number[] = [];

    // 0 を含めたい場合（min<=0<=max）は先に入れておく（重複回避）
    if (min <= 0 && 0 <= max && 0 < start) ticks.push(0);

    for (let t = start; t <= end; t += step) ticks.push(t);
    // 端が 250 の倍数でない場合、最終点を追加したくなければここは不要（位置ズレ防止）
    return ticks;
};

export function buildIndexMap<T extends DataWithArrays>(
    data: ChartDatum<T>[],
    indexKey: string,
    valueKey: string
): Map<number, number> {
    const m = new Map<number, number>();
    for (const d of data) m.set(Number(d[indexKey]), Number(d[valueKey]));
    return m;
};
